import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
const EmptyRooster = ({}) => {
  return (
    <>
      <Wrapper>
        <Container>
          {/* <FontAwesomeIcon
        style={{
            width: "80%",
            height: "80%",
            color: "rgba(255,255,255,.4)"
        }}
        icon={faBan} /> */}
          {/* <FontAwesomeIcon
        style={{
            width: "100%",
            height: "100%",
            color: "rgba(255,255,255,.4)",
            position: "absolute"
        }}
        icon={faX} /> */}
          <FontAwesomeIcon
            style={{
              width: "60%",
              height: "60%",
              color: "rgba(255,255,255,.4)",
            }}
            icon={faUser}
          />
        </Container>
      </Wrapper>
    </>
  );
};
export default EmptyRooster;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 0.5rem 0;

  @media (max-width: 350px) {
    /* font-size: smaller; */
  }
`;
const Container = styled.div`
  aspect-ratio: 1 / 1;
  width: 100%;
  border: 1px solid rgb(38, 38, 38);
  box-shadow: 0px 3px 5px rgba(56, 136, 216, 1);
  padding: 0.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 8px;
`;
